export enum NodeType {
    ELEMENT = "ELEMENT",
    CONTAINER = "CONTAINER",
    LABEL = "LABEL",
}